import _once from "lodash/once";
import { getAnalytics } from './lib/registry';
import { store } from './redux';
import { configFailed } from './actions/config';
import { createAnalytics } from './actions/analytics';
const initializeAnalytics = _once(async function initializeAnalytics(name, config) {
  const analytics = getAnalytics(name);
  if (!analytics) {
    const err = new Error(`Missing analytics provider '${name}'. Please use 'registerAnalytics' to register it.`);
    store.dispatch(configFailed(err));
  } else {
    const instance = await analytics.init({
      config
    });
    store.dispatch(createAnalytics(instance));
  }
});
store.subscribe(() => {
  const state = store.getState();
  if (state) {
    var _state$config$analyti;
    const analyticsName = (_state$config$analyti = state.config.analytics) === null || _state$config$analyti === void 0 ? void 0 : _state$config$analyti.name;
    if (analyticsName && !state.analytics.implementation) {
      const analyticsConfig = state.config.analytics;
      initializeAnalytics(analyticsName, analyticsConfig);
    }
  }
});